<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title" style="display: flex; justify-content: space-between; width: 100%">
        <h3 class="card-label">Phòng ban xử lý</h3>
        <div class="view-mode-toggle">
          <button
            type="button"
            class="view-mode-btn"
            :class="{ 'is-active': viewMode === 'all' }"
            @click="setViewMode('all')"
          >
            Tất cả
          </button>
          <button
            type="button"
            class="view-mode-btn"
            :class="{ 'is-active': viewMode === 'individual' }"
            @click="setViewMode('individual')"
          >
            Cá nhân
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="example mb-10">
        <div class="row">
          <div class="col-md-2">
            <div class="form-group">
              <label for="ticket_id">Tìm ticket
                <span class="text-danger"></span></label>
              <el-input
                  id="ticket_id"
                  type="text"
                  v-model="query.ticket_id"
                  placeholder="Nhập mã, nội dung ticket"
                  clearable
              ></el-input>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="user">Khách hàng
                <span class="text-danger"></span></label>
              <el-input
                  id="user"
                  type="text"
                  v-model="query.keyword"
                  placeholder="Tên, SĐT, Mã học viên..."
                  clearable
              ></el-input>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label class="d-block" for="status">Trạng thái</label>
              <el-select id="status" v-model="query.processing_status" clearable filterable multiple placeholder="Trạng thái" class="w-100">
                <el-option v-for="status in FEEDBACK_STATUS"
                           :key="status.value"
                           :label="status.label"
                           :value="status.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label class="d-block" for="office">Phòng ban xử lý</label>
              <el-select id="office" v-model="query.phong_ban_xu_ly"
                         clearable filterable multiple
                         placeholder="Chọn Phòng ban xử lý..."
                         class="w-100"
              >
                <el-option v-for="item in departments"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-2" v-if="!isIndividual && currentUser.user.permission.includes(permission.DIEU_PHOI_TICKET)">
            <div class="form-group">
              <label class="d-block" for="handler">Người xử lý</label>
              <el-select
                  ref="userSelect"
                  v-model="query.assigned_user_id"
                  filterable size="large"
                  remote class="w-100"
                  clearable
                  placeholder="Tìm kiếm người xử lý"
                  :remote-method="remoteMethod"
                  :loading="loading">
                <el-option
                    v-for="item in handlerOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="create_date">Danh mục
                <span class="text-danger"></span></label>
              <el-select id="status"
                         v-model="query.category_status"
                         clearable
                         filterable
                         multiple
                         reserve-keyword
                         collapse-tags
                         placeholder="Danh mục"
                         class="w-100">
                <el-option v-for="(item, index) in ticket_categories"
                           :key="index"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label>Độ ưu tiên</label>
              <el-select v-model="query.priorities" filterable class="w-100" placeholder="Độ ưu tiên" clearable>
                <el-option label="Tiêu chuẩn" :value="1"> </el-option>
                <el-option label="Ưu tiên" :value="2"> </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="create_date">Thời gian chuyển phòng ban
                <span class="text-danger"></span></label>
              <date-picker
                  placeholder="Chọn thời gian"
                  format="DD-MM-YYYY"
                  id="create_date"
                  range 
                  valueType="YYYY-MM-DD" v-model="query.date_range_update">
              </date-picker>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="follow">Mốc thời gian theo dõi
                <span class="text-danger"></span></label>
              <date-picker
                  placeholder="Chọn thời gian"
                  format="DD-MM-YYYY"
                  id="follow"
                  range 
                  valueType="YYYY-MM-DD" v-model="query.timeline">
              </date-picker>
            </div>
          </div>
          <div class="col-md-2 mt-8">
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-primary font-weight-bold mr-2" :disabled="is_disable_search"
                :class="{ 'spinner spinner-white spinner-left': is_disable_search }" @click="searchFeedback">
                Tìm kiếm
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isIndividual && currentUser.user.permission.includes(permission.DIEU_PHOI_TICKET)" style="margin: 20px 0; display: flex; align-items: center; gap: 20px">
        <div style="margin: 20px 0; display: flex; align-items: center; gap: 20px" v-if="ticketSelectedList.length > 0">
          <span>Đã chọn ({{ ticketSelectedList.length }})</span>
          <el-button type="success" style="background: #500DA7; color: white; border: 0"
                     @click="isAddPersonInCharge = true">
            <i class="el-icon-s-promotion" style="color: white"></i> Điều phối ticket
          </el-button>
          <el-button type="info" style="background: #E6E6E6; border: 0; display: flex; align-items: center"
                     @click="cancelSelected">
            <i class="el-icon-close" style="color: black"></i> Hủy
          </el-button>
        </div>
      </div>
      <div class="example-preview table-responsive b-table-sticky-header">
        <table :aria-busy="isBusy" class="table table-hover table-bordered table-hover b-table">
          <thead class="thead-light">
            <tr>
              <th scope="col" v-if="!isIndividual && currentUser.user.permission.includes(permission.DIEU_PHOI_TICKET)" class="w-[40px]" style="background: #F8F8F8">
                <el-checkbox v-model="isSelectedAll" :disabled="disableSelectedAll"
                             @change="selectedAllTicket" />
              </th>
              <th scope="col" class="min-w-80px">Mã ticket</th>
              <th scope="col" class="min-w-130px">Bên gửi ticket</th>
              <th scope="col" class="min-w-120px">Danh mục</th>
              <th scope="col" class="min-w-150px">Trạng thái</th>
              <th scope="col" class="min-w-110px">Độ ưu tiên</th>
              <th scope="col" class="min-w-130px">Phòng ban xử lý</th>
              <th v-if="!isIndividual" scope="col" class="min-w-170px">Người xử lý</th>
              <th scope="col" class="min-w-140px">Mốc theo dõi</th>
              <th scope="col" class="min-w-120px">Thao tác</th>
            </tr>
          </thead>
          <tbody v-if="isBusy">
            <tr role="row" class="b-table-busy-slot" >
              <td colspan="16" role="cell" class="text-center">
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="tickets && tickets.length > 0" >
            <tr v-for="(item, index) in tickets" :key="index">
              <td v-if="!isIndividual && currentUser.user.permission.includes(permission.DIEU_PHOI_TICKET)">
                <el-checkbox v-model="item.selected" :disabled="item.disabled" @change="getTicketSelectedList" />
              </td>
              <td>{{ item.id }}</td>
              <td>{{ (item.is_auto === 2 || item.is_auto === 1) && (item.category_chamsoc != 1 && item.category_chamsoc != 2 && item.category_chamsoc != 6 && item.category_chamsoc != 10 && item.category_chamsoc != 11)  ? 'QLHV' : 'TTHT'}}</td>
              <td>{{ item.category_ticket ? item.category_ticket && item.category_ticket.name : category_chamsoc_define[item.category_chamsoc] }} </td>
              <td>
                <span class="p-2 rounded" :class="FEEDBACK_STATUS.find((v) => v.value === Number(item.processing_status))
                 && FEEDBACK_STATUS.find((v) => v.value === Number(item.processing_status)).bg_color " >
                  {{ FEEDBACK_STATUS.find((v) => v.value === Number(item.processing_status)) && FEEDBACK_STATUS.find((v) => v.value === Number(item.processing_status)).label }}
                </span>
              </td>
              <td> <p :style="renderPriority(item).styleColor"> {{ renderPriority(item).label }} </p> </td>
              <td>{{ item.phong_ban_xu_ly_rel && item.phong_ban_xu_ly_rel.name }}</td>
              <td v-if="!isIndividual">{{ getHandler(item) }}</td>
              <td>{{ getDate(item.timeline) }}</td>

              <td class="sticky-action">
                <router-link :to="{name: 'show-feedback', params: {id: item.id}}"
                    title="Chi tiết ticket" class="btn sm btn-icon btn-outline-success">
                  <i class="far fa-eye"></i>
                </router-link>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="17" class="text-center">Chưa có dữ liệu</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-end mt-6 bold">Tổng số bản ghi : {{ total }}</div>
    </div>
    <div class="edu-paginate mx-auto text-center">
      <paginate
          v-model="page"
          :page-count="last_page"
          :page-range="3"
          :margin-pages="1"
          :click-handler="clickCallback"
          :prev-text="'Trước'"
          :next-text="'Sau'"
          :container-class="'pagination b-pagination'"
          :pageLinkClass="'page-link'"
          :next-link-class="'next-link-item'"
          :prev-link-class="'prev-link-item'"
          :prev-class="'page-link'"
          :next-class="'page-link'"
          :page-class="'page-item'"
      >
      </paginate>
    </div>
    <el-dialog
        title="Điều phối ticket" :show-close="false"
        :visible.sync="isAddPersonInCharge"
        v-if="isAddPersonInCharge" width="35%"
    >
      <hr style="padding: 0; margin-top: -20px"/>
      <AddPersonalHandleTicket
          @closeDialog="isAddPersonInCharge = false"
          @workCoordinationSuccess="workCoordinationSuccess"
          @getTicketList="getList"
          :list-ticket-selected="ticketSelectedList"/>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DatePicker from 'vue2-datepicker';

import 'vue2-datepicker/index.css';
import moment from 'moment-timezone';
import '@/assets/sass/table/tableCommon.scss'
import {GET_DEPARTMENTS, GET_TICKET_CATEGORIES, GET_TICKETS} from "@/core/services/store/ticket/ticket.module";
import {FEEDBACK_STATUS, TICKET_PROPERTY, TICKET_EVALUATE, TICKET_FROM, FEEDBACK_TICKET_STAR} from "@/core/option/ticketOption";
import {CATEGORY_LIST} from "@/core/services/store/user/ticket.module";
import {FIND_USER_BY_KEYWORD} from "../../../core/services/store/okrs/okr.module";
import AddPersonalHandleTicket from "./components/AddPersonalHandleTicket.vue";

export default {
  components: {
    AddPersonalHandleTicket,
    DatePicker,
  },
  name: "FeedbackIndex",
  data() {
    return {
      is_disable_search: false,
      isBusy: false,
      branches: [],
      FEEDBACK_STATUS,
      TICKET_PROPERTY,
      TICKET_EVALUATE,
      TICKET_FROM,
      FEEDBACK_TICKET_STAR,
      centers: [],
      sources: [],
      tickets: [],
      handlerOptions: [],
      loading: false,
      queryUser: '',
      ticketSelectedList: [],
      isAddPersonInCharge: false,
      isSelectedAll: false,
      disableSelectedAll: false,
      viewMode: 'all',
      // Paginate
      page: 1,
      last_page: 1,
      query: {
        is_auto: [],
        ticket_id: '',
        response: '',
        property: [],
        evaluate: [],
        date_range_update: [],
        keyword: '',
        processing_status: [],
        phong_ban_xu_ly: [],
        assigned_user_id: '',
        timeline: [],
        content: '',
        category_status: '',
        priorities: ''
      },
      date_filter_default: [],
      districtsByProvince: [],
      is_auto_default: [],
      //Phòng ban xử lý
      departments: [],
      ticket_categories: [],
      currentStudentAmount: {},
      category_chamsoc_define: {
        1: 'Nghỉ học 2 buổi',
        2: 'Điểm kiểm tra thấp',
        3: 'Không làm bài',
        4: 'ChƯa đóng tiền học',
        5: 'Đã đóng tiền học',
        6: 'Feedback thấp',
        7: 'Nghỉ học 1 buổi',
        8: 'Nghỉ học 1 buổi',
        9: 'Hướng dẫn app cho phụ huynh',
        10: 'Kết quả BTVN không tốt',
        11: 'Không làm BTVN',
        13: 'Nhắc nhở bảo hành',
        14: 'Nghỉ 1 buổi không phép',
        15: 'Nghỉ buổi khai giảng',
        16: 'Chăm sóc học viên giữa khóa'
      },
      total: 0,
      listCategory: []
    }
  },
  created() {
    this.getDateFilterDefault();
    this.getListDepartments();
    this.getListTicketCategories();
    this.getList();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Phản hồi", route: '#'},
      {title: "Xử lý phản hồi"}
    ]);
  },
  computed: {
    ...mapGetters(["currentUser"]),
    isIndividual() {
      return this.viewMode === 'individual';
    }
  },
  watch: {
    viewMode() {
      this.searchFeedback();
    }
  },
  methods: {
    getDateFilterDefault() {
      const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
      const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');
      this.date_filter_default.push(startOfMonth);
      this.date_filter_default.push(endOfMonth);
    },
    getList() {
      this.pullParamsUrl();
      this.callApiGetList();
    },
    getUsers() {
      const payload = {
        keyword: this.queryUser,
      }
      this.$store.dispatch(FIND_USER_BY_KEYWORD, payload).then(res => {
        if (!res.error) {
          this.handlerOptions = res.data.map(item => {
            return {
              id: item.id,
              name: `${item.id + 100000} - ${item.name} - ${item.department_name}`,
            }
          }) ?? []
        }
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.queryUser = query
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.getUsers()
        }, 400);
      } else {
        this.teacherOptions = [];
      }
    },
    getTicketSelectedList() {
      this.ticketSelectedList = this.tickets.filter(item => item.selected)
    },
    setViewMode(mode) {
      if (this.viewMode === mode) return;
      this.viewMode = mode;
      this.isSelectedAll = false;
      this.ticketSelectedList = [];
    },
    selectedAllTicket() {
      if (this.isSelectedAll) {
        this.tickets.filter(item => !item.selected).forEach(item => item.selected = true);
        this.ticketSelectedList = this.tickets.filter(item => item.selected && +item.status !== 3)
      } else {
        this.tickets.filter(item => item.selected).forEach(item => item.selected = false);
        this.ticketSelectedList = []
      }
    },
    workCoordinationSuccess() {
      this.ticketSelectedList = []
      this.isSelectedAll = false
    },
    cancelSelected() {
      this.tickets.filter(item => item.selected)
      this.tickets = this.tickets.map(task => {
        return {...task, selected: false};
      })
      this.tickets.filter(item => item.selected).forEach((item) => item.selected = false);
      this.ticketSelectedList = []
      this.isSelectedAll = false;
    },
    getHandler(handler) {
      if (handler.assigned_user?.id && handler.assigned_user?.name) {
        return `${handler?.assigned_user?.id + 100000} - ${handler.assigned_user?.name}`
      }
      if (!handler.assigned_user?.id && handler.assigned_user?.name) {
        return `${handler.assigned_user?.name}`
      }
      return ''
    },
    getListDepartments(){
      this.$store.dispatch(GET_DEPARTMENTS, { status: 1, all: true }).then((res) => {
        this.departments = res.data;
      })
    },
    async getListTicketCategories(){
      await this.$store.dispatch(GET_TICKET_CATEGORIES,{
        departmentIds: this.query.phong_ban_xu_ly,
        status: 1, limit: 100000,
        join: true
      }).then((res) => {
        this.ticket_categories = res.data;
        Array.prototype.push.apply(this.ticket_categories, CATEGORY_LIST);
        this.ticket_categories.map(function (item) {
          item.value_prop = item.id + ',' + item.status;
          return item;
        })
      })
    },
    pullParamsUrl() {
      this.page = this.$route.query.page ? Number(this.$route.query.page) : 1
      this.viewMode = this.$route.query.individual ? this.$route.query.individual : 'all'
      this.pullParamsFromUrl(this.query);
      this.query.is_auto =this.$route.query.is_auto ? this.$route.query.is_auto.split(',').map(Number) : this.is_auto_default;
      this.query.evaluate = this.$route.query.evaluate ? this.$route.query.evaluate.split(',').map(item => isNaN(item) ? item : Number(item)) : [];
      this.query.date_range_update = this.$route.query.date_range_update ? this.$route.query.date_range_update : [];
    },
    pushParamsToUrl() {
      this.pushParamsUrl({
        page: this.page,
        individual: this.viewMode,
        ...this.query,
        is_auto: this.query.is_auto.length === 0 ? this.is_auto_default : this.query.is_auto,
        date_range_update: this.query.date_range_update ? this.query.date_range_update : this.date_filter_default,
      });
    },
    clickCallback(obj) {
      this.page = obj
      this.$router.push({
        path: '',
        query: {
          page: this.page,
          ...this.query,
          date_range_update: this.query.date_range_update ? this.query.date_range_update : this.date_filter_default,
          type_filter: 'Phòng ban xử lý',
        }
      })
      this.callApiGetList();
    },
    callApiGetList() {
      this.is_disable_search = true;
      this.is_auto_default = this.TICKET_FROM.map((item) => item.value);

      this.isBusy = true;
      this.$store.dispatch(GET_TICKETS, {
        page: this.page,
        ...this.query,
        individual: this.viewMode === 'individual',
        is_auto: this.query.is_auto.length === 0 ? this.is_auto_default : this.query.is_auto,
        date_range_update: this.query.date_range_update ? this.query.date_range_update : this.date_filter_default,
        not_show: true,
        search: true,
        type_filter: 'Phòng ban xử lý',
      }).then((res) => {
        if (!res.error) {
          this.isBusy = false;
          this.tickets = res.data.data.map(item => {
            return {
              selected: false,
              disabled: +item.status === 3,
              ...item,
            }
          });
          this.last_page = res.data.last_page;
          this.total = res.data.total;
        }
        this.is_disable_search = false;
      }).finally(() => {
      });
    },
    searchFeedback() {
      this.filterData();
    },
    filterData() {
      this.page = 1
      this.cancelSelected()
      this.pushParamsToUrl();
      this.callApiGetList();
    },
    renderPriority(ticket) {
      const priority = ticket.priority;
      let priorityNumber = '';
      if (priority){
        priorityNumber = this.TICKET_PROPERTY.find( item => priority === item.value).value;
      }
      let result = {label: '', styleColor: ''}
      switch (priorityNumber){
        case 1 :
          result.label = 'Tiêu chuẩn';
          result.styleColor = 'color: #000000';
          break;
        case 2 :
          result.label = 'Ưu tiên';
          result.styleColor = 'color: #FF0B0B';
          break;
      }
      return result;
    },
    async changePhongBanXuLy(){
      await this.getListTicketCategories();
      this.filterData()
    },
    getDate(date) {
      if (!date) return 'Chưa có'
      return moment(date).format('HH:mm:ss DD-MM-YYYY')
    }
  }
}
</script>
<style>
.bg-yellow {
  background-color: #FFC107;
}
.bg-red-error {
  background-color: red;
}
.bg-violet {
  background-color: #8950FC;
}
.bg-suc {
  background-color: #1BC5BD;
}
.bg-processing {
  background-color: #0066FF;
}
.view-mode-toggle {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  background: #F0F0FF;
  border-radius: 9999px;
}

.view-mode-btn {
  padding: 4px 12px;
  border: none;
  border-radius: 9999px;
  background: transparent;
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  transition: background 0.15s, color 0.15s;
}

.view-mode-btn:hover {
  color: #374151;
}

.view-mode-btn.is-active {
  background: #5F04B4;
  color: #fff;
}
td {
  text-align: left !important;
}
</style>
